<!-- Vue single-file component -->
<template>
  <div ref="googleMap" style="width: 100%; height: 300px"></div>

  <ul class="text-success">
    <li v-for='item in berryPrices' :key="item.id">
     {{ item.berry }} <b>{{ item.price }} руб.</b>
    </li>
  </ul>

</template>

<script>
import { ref, onMounted } from "vue"
import axios from 'axios'

export default {
  name: "Map",
  setup(props) {
    const berryPrices = ref([])
    const googleMap = ref(null)

    const initMap = () => {
      const freshberry = {
        lat: 61.67256,
        lng: 33.606611,
      };
      const map = new google.maps.Map(googleMap.value, {
        zoom: 11,
        center: freshberry,
      });
      const contentString =
        '<div id="content">' +
        '<div id="siteNotice">' +
        "</div>" +
        '<h1 id="firstHeading" class="firstHeading">Завод Freshberry</h1>' +
        '<div id="bodyContent">' +
        "<p>Мы ежегодно заготавливаем более <b>4000 тонн</b> " +
        "дикорастущих ягод: <b> брусники, черники, морошки и клюквы.</b>";
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      });
      const marker = new google.maps.Marker({
        position: freshberry,
        map,
        title: "Freshberry",
        icon: "./logo.png",
      });

      marker.addListener("click", () => {
        infowindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        });

        loadBerryData()
      });
    }
    
    const loadScript = () => {
      let scriptId = "map-api-script";
      let mapAlreadyAttached = !!document.getElementById(scriptId);
      if (mapAlreadyAttached) {
        if (window.google) initMap();
      } else {
        window.mapApiInitialized = initMap;

        let script = document.createElement("script");
        script.id = scriptId;
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyBuoP4ZpwtLcJVv9VO65ZqQJMHZSvgDwu4&libraries=places,geometry&callback=mapApiInitialized";
        document.body.appendChild(script);
      }
    }

    const loadBerryData = async () => {
      let reqBerryPrices = await axios.get(process.env.VUE_APP_BASE_URL + 'getMapData')
      berryPrices.value = reqBerryPrices.data
    }

    onMounted(loadScript)

    return {
      berryPrices,
      googleMap,
    }
  }
};
</script>